export function BuildFilterDomain(layout, filtersObj) {
  const domain = [];

  Object.entries(filtersObj).forEach(([key, val]) => {
    const field = layout.fields[key];
    if (!val || !field) return;

    switch (field.type) {
      case "selection":
        if (typeof val === "object" && val.id) {
          domain.push([key, "=", val.id]);
        } else {
          domain.push([key, "=", val]);
        }
        break;

      case "many2one":
        if (val && val.id) domain.push([key, "=", val.id]);
        break;

      case "one2many":
        if (val && val.id) {
          const sub = field.filterField;
          domain.push([`${key}.${sub}`, "in", [val.id]]);
        }
        break;

      case "date":
        if (val instanceof Date) {
          domain.push([key, "=", val.toISOString().split("T")[0]]);
        } else {
          domain.push([key, "=", val]);
        }
        break;

      case "date_2":
        if (val) {
          const start =
            typeof val === "string" ? val : val.toISOString().split("T")[0];
          const next = new Date(start);
          next.setDate(next.getDate() + 1);
          const end = next.toISOString().split("T")[0];
          domain.push([key, ">=", start]);
          domain.push([key, "<", end]);
        }
        break;

      default:
        domain.push([key, "=", val]);
        break;
    }
  });

  return domain;
}
